import api from "./api";

export const authService = {
  superadminLogin: (credentials) => api.post("/auth/superadmin/login", credentials),
  adminLogin: (credentials) => api.post("/auth/admin/login", credentials),
  userLogin: (credentials) => api.post("/auth/user/login", credentials),
};

